import React from 'react'
import styled from 'styled-components'

function ComparisonPage({report}) {
  return (
    <ComparisonContainer>
      <ScreenShot src={require(`images/${report}.png`)} />
    </ComparisonContainer>
  )
}

const ComparisonContainer = styled.div`
  margin: 2rem auto;
`;

const ScreenShot = styled.img`
  width: 100%;
`;

export default ComparisonPage
